import React from 'react';

interface CustomIconProps {
  filled?: boolean;
  color?: string;
}

const SecBackward: React.FC<CustomIconProps> = () => (
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.9331 7.70391H18.1051L15.5691 10.2399L16.9831 11.6539L21.9331 6.70391L16.9831 1.75391L15.5691 3.16791L18.1051 5.70391H10.9331C8.81137 5.70391 6.77654 6.54676 5.27625 8.04705C3.77596 9.54734 2.93311 11.5822 2.93311 13.7039C2.93311 15.8256 3.77596 17.8605 5.27625 19.3608C6.77654 20.8611 8.81137 21.7039 10.9331 21.7039H11.9331V19.7039H10.9331C9.34181 19.7039 7.81568 19.0718 6.69046 17.9465C5.56525 16.8213 4.93311 15.2952 4.93311 13.7039C4.93311 12.1126 5.56525 10.5865 6.69046 9.46127C7.81568 8.33605 9.34181 7.70391 10.9331 7.70391ZM14.2086 15.5341V21.6907H15.9584V14.1299H12.6965V15.5341H14.2086ZM18.2763 21.6151C18.7948 21.7519 19.3168 21.8203 19.8425 21.8203C20.5626 21.8203 21.153 21.7051 21.6139 21.4747C22.0819 21.2371 22.4276 20.931 22.6508 20.5566C22.874 20.1749 22.9856 19.7609 22.9856 19.3145C22.9856 18.868 22.8812 18.4684 22.6724 18.1155C22.4636 17.7627 22.1287 17.4855 21.6679 17.2839C21.2142 17.075 20.613 16.9706 19.8641 16.9706H19.2439L19.3717 15.5341H22.5212V14.1299H17.9091L17.5203 18.3856H19.4537C19.9145 18.3856 20.2709 18.4252 20.523 18.5044C20.7822 18.5836 20.9622 18.6988 21.063 18.85C21.1638 19.0012 21.2142 19.174 21.2142 19.3685C21.2142 19.6781 21.0882 19.9193 20.8362 20.0921C20.5842 20.265 20.2385 20.3514 19.7993 20.3514C19.4104 20.3514 19.0252 20.2902 18.6436 20.1677C18.2691 20.0453 17.9379 19.8797 17.6499 19.6709L16.9586 21.0102C17.3258 21.2695 17.7651 21.4711 18.2763 21.6151Z'
      fill='white'
    />
  </svg>
);

export default SecBackward;
